<template>
  <div>
    <div class='is-flex' v-if="!tokenUser.ghumana" :class='isMovil ? "is-justify-center" : "" '>
      <button class="button is-link is-outlined" v-on:click='activeMenu'>Menú</button>
      <button
          class="button is-link"
          style="margin-left: 5px"
          v-tooltip='"Crear relación manual"'
          v-on:click='showModalRelation()'
      >
          <span class="icon">
            <i class="material-icons">add_circle</i>
          </span>
      </button>
      <button
          class="button is-link"
          style="margin-left: 5px"
          v-tooltip='"Descargar los usuarios pendientes"'
          v-on:click='downloadRelationsPending'
      >
          <span class="icon">
            <i class="material-icons">download</i>
          </span>
      </button>
      <button
          class="button is-dark"
          style="margin-left: 5px"
          v-tooltip='"Enviar correo a todos los pendientes"'
          v-on:click='sendAllEmails'
      >
          <span class="icon">
            <i class="material-icons">email</i>
          </span>
      </button>
    </div>
    <nav id='menuFilter' v-if='active' class="panel">
      <div class="panel-heading">
          <div class='is-size-6 is-flex'>
            <!-- Title -->
          </div>
          <button class="delete" aria-label="delete" v-on:click='activeMenu'></button>
      </div>
      <div class='panel-body'>
        <p class="panel-tabs has-text-centered">
          <span class='has-text-weight-bold'>Relaciones</span>
        </p>
        <a class="panel-block file-label" :class='elements[0].active ? "is-active" : ""'>
          <input v-on:change='uploadRelations' ref='inputFileRelations' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
          {{ elements[0].name }}
        </a>
        <a class="panel-block" :class='elements[1].active ? "is-active" : ""' v-on:click='downloadTemplateRelations'>
          {{ elements[1].name }}
        </a>
        <p class="panel-tabs has-text-centered">
          <span class='has-text-weight-bold'>Respuestas</span>
        </p>
        <a class="panel-block file-label" :class='elements[2].active ? "is-active" : ""'>
          <input v-on:change='uploadResponses' ref='inputFileResponses' type='file' class='file-input' name='file' id='file' :accept="inputAccept" style='cursor: pointer; width: 100%; height: 100%'>
          {{ elements[2].name }}
        </a>
        <a class="panel-block" :class='elements[3].active ? "is-active" : ""' v-on:click='downloadTemplateResponses'>
          {{ elements[3].name }}
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import apiServices from '../../../services/yungol-services'
const XLSX = require('xlsx')

export default {
  data(){
    return {
      active: false,
      elements: [
        {name:'Cargar Relaciones', tooltip: "Cargar Excel de datos de relaciones", active: false},
        {name:'Descargar Plantilla', tooltip: "Descargar plantilla de datos de respuestas", active: false},
        {name:'Cargar Respuestas', tooltip: "Cargar Excel de datos de respuestas", active: false},
        {name:'Descargar Plantilla', tooltip: "Descargar plantilla de datos de respuestas", active: false},
      ],
      filesAccept: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"],
      inputAccept : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    }
  },
  computed: {
    ...mapState(["isOculto", 'isMovil', 'tokenUser']),
  },
  props:{
    gridApi: Object,
    proceso: Object,
    widthCols: Function
  },
  methods:{
    activeMenu(){
      this.active ? this.active = false : this.active = true;
    },
    uploadResponses(e) {
      const _this = this;
      let task;
      const files = e.target.files;

      if (files.length) {
        const file = files[0];
        // Validate type file
        if (!this.filesAccept.includes(file.type)) return this.errorFile('inputFileResponses');

        // Save file
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
            "state_changed",
            (snapshot) => {},
            (err) => {
              console.log("error subiendo el archivo", err);
              this.$store.dispatch("notify", {
                message: `Hubo un error al subir el archivo, intentalo de nuevo.`,
                type: "is-error",
              });
            },
            async () => {
              try {
                const url = await task.snapshot.ref.getDownloadURL();
                const data = {
                  url: url,
                  proceso: this.proceso._id,
                };
                const result = await apiServices.post(`/saveresponseslote`, data);
                if (result.data) {
                  await this.$store.dispatch("notify", {
                    message: `El archivo se cargo correctamente.`,
                    type: "is-success",
                  });
                  this.$emit('getRelations')
                  this.$emit('getParticipation')
                }
              } catch (err) {
                console.log("ocurrio un error", err);
                await this.$store.dispatch("notify", {
                  message: `Hubo un error al subir el archivo, intentalo de nuevo.`,
                  type: "is-error",
                });
              }
            }
        );
      }
    },
    async downloadTemplateResponses() {
      try {
        const result = await apiServices.post(
            `/plantillarespuestaslider`,
            {procesoid: this.proceso._id},
            {responseType: "blob"}
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Plantilla_Respuestas - ${ahora}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (err) {
      }
    },
    uploadRelations(e) {
      const _this = this;
      let task;
      const files = e.target.files;

      if (files.length) {
        const file = files[0];
        // Validate type file
        if (!this.filesAccept.includes(file.type)) return this.errorFile('inputFileRelations');

        // Save file
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
            "state_changed",
            (snapshot) => {},
            (err) => {
              console.log("error subiendo el archivo", err);
              this.$store.dispatch("notify", {
                message: `Hubo un error al subir el archivo, intentalo de nuevo.`,
                type: "is-error",
              });
            },
            async () => {
              try {
                const url = await task.snapshot.ref.getDownloadURL();

                const data = {
                  url: url,
                  proceso: this.proceso._id,
                };
                const result = await apiServices.post(
                    `/saverelacioneslote`,
                    data
                );
                if (result.data) {
                  await this.$store.dispatch("notify", {
                    message: `El archivo se cargo correctamente.`,
                    type: "is-success",
                  });
                  this.$emit('getRelations')
                  this.$emit('getParticipation')
                }
              } catch (err) {
                console.log("ocurrio un error", err);
                await this.$store.dispatch("notify", {
                  message: `Hubo un error al subir el archivo, intentalo de nuev1o.`,
                  type: "is-error",
                });
              }
            }
        );
      }
    },
    downloadTemplateRelations() {
      let dataExc = [
        {
          evaluado: "correoevaluado01@correo.com",
          evaluador: "correoevaluador01@correo.com"
        },
        {
          evaluado: "correoevaluado02@correo.com",
          evaluador: "correoevaluador02@correo.com"
        },
        {
          evaluado: "correoevaluado03@correo.com",
          evaluador: "correoevaluador03@correo.com"
        }
      ]
      let ws = XLSX.utils.json_to_sheet(dataExc);
      ws["!cols"] = this.widthCols(dataExc)
      const workbook = XLSX.utils.book_new();
      const filename = "Ejemplo_Relaciones - Liderazgo";
      XLSX.utils.book_append_sheet(workbook, ws, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    downloadRelationsPending(){
      this.$emit('excelEarrings')
    },
    showModalRelation(){
      if (this.active){
        this.activeMenu()
      }
      this.$emit("showModalEmployee");
    },
    async sendAllEmails(){
      const config = {
        title: '¿Estás seguro?',
        text: "Enviaras un correo a todos los empleados de las relaciones.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, enviar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          let result;
          const d = {
            proceso: this.proceso._id,
          };
          try {
            result = await apiServices.post(`/enviarcorreolote`, d);
            if (result.isDenied) {
              await this.$swal({
                text: 'Error al enviar todos los correos.',
                icon: 'error',
                showConfirmButton: false,
                timer: 1700
              })
            }else if (result.data) {
              await this.$swal({
                text: 'Correo enviados correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              this.$emit('getRelations')
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    // Helpers
    deleteFile(ref){
      this.$refs[ref] = null;
    },
    errorFile(ref){
      this.$store.dispatch("notify", {
        message: `El archivo no es un Excel.`,
        type: "is-danger",
      });
      this.deleteFile(ref)
    },
  },
  watch:{}
}
</script>
<style>
.panel-heading {
  display: flex;
  justify-content: space-between;
}

#menuFilter{
  margin-top: 15px !important;
  background: white;
  position: absolute;
  z-index: 250;
  max-height: 360px !important;
}

#menuFilter .panel-body{
  max-height: 300px !important;
  overflow: auto;
}

#menuFilter .panel-block{
  background-color: white;
}
#menuFilter .panel-block:hover{
  background-color: #f5f5f5 !important;
}

#menuFilter .is-active {
  border-left: solid 3px #41aae7;
  color: #363636;
  background: aliceblue;
}

.panel-block .panel-icon .material-icons {
  line-height: unset !important;
}

.tooltip-menuTable {
  z-index: 251 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/menuTable.vue